import { useInfiniteQuery } from '@tanstack/react-query';

import { RQ_LIKED_PRODUCTS } from '@/modules/ReactQuery/cacheKeys';
import { fetchLikedProducts } from '@/modules/likes/api';
import { LIKES_PAGE_SIZE } from '@/modules/likes/constants';
import { getNextPageParam } from '@/modules/pagination/getNextPageParam';

export function useLikedProducts({
  sellerId,
  hideSoldProducts,
}: {
  sellerId?: number;
  hideSoldProducts?: boolean;
}) {
  return useInfiniteQuery({
    queryKey: [RQ_LIKED_PRODUCTS, { sellerId, hideSoldProducts }],
    queryFn: ({ pageParam }: { pageParam: undefined | string }) =>
      fetchLikedProducts(
        {
          after: pageParam,
          limit: String(LIKES_PAGE_SIZE),
          hide_sold_products: String(!!hideSoldProducts),
        },
        Number(sellerId)
      ),
    initialPageParam: undefined,
    getNextPageParam,
    enabled: !!sellerId,
  });
}
